import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormulaTesterComponent, Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { CustomActionParametersComponent } from 'src/app/forms/simple-datagrid/custom-action-parameters/custom-action-parameters.component';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DialogService } from 'src/app/services/dialog.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { FieldsProperties, UserConfigServices } from 'src/app/services/user-config.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

@Component({
    selector: 'app-form-field-properties-detail',
    templateUrl: './form-field-properties-detail.component.html',
    styleUrls: ['./form-field-properties-detail.component.scss'],
    standalone: false
})
export class FormFieldPropertiesDetailComponent implements OnInit {
  isSelectField: boolean;
  selectedValues: any;


  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>,
   public uas:UserAuthenticationServices, public ucs:UserConfigServices,
   public dialogServices:DialogService,
   public ThemeService:ThemeService
   ) {}
   
  step = 0;
  /** spinner NG-ZORRO da aba Padrões (substitui o ngx-spinner 'prefajustes') */
  prefLoading = false;

  /** handler do nz-collapse: ativa o painel e define a visibilidade das ações */
  onPanelChange(active: boolean, stepIndex: number, showActions: boolean): void {
    if (active) {
      this.setStep(stepIndex);
      this.showActions = showActions;
    }
  }
  information:columnsDef;
  entityDesc:string;
  entityName:string;
  decimal:number=null;
  decimalForm:boolean = false;
  decimalText:string = null;
  codecompany:string;
  readonly:boolean = false;
  readonlyForm:boolean = false;
  readonlyText:string = null;
  required:boolean = false;
  requiredForm:boolean = false;
  requiredText:string = null;
  nullable:boolean = true;
  nullableForm:boolean = false;
  nullableText:string = null;
  defaultValue:string =null;
  defaultValueForm:Boolean =false;
  defaultValueText:string = null;
  showActions = false;
  fieldProperties:FieldsProperties;
  editDescMode = false;
  description:string=null;
  descriptionForm:Boolean =false;
  descriptionText:string=null;
  minLength:number=null;
  minLengthForm:Boolean =false;
  minLengthText:string=null;
  maxLength:number=null;
  maxLengthForm:Boolean =false;
  maxLengthText:string=null;
  expressionText:string=null;
  copyclean:boolean=false;
  row:Object;
  group:UntypedFormGroup;
  toolTipText:string=null;
  @Input() steps = [0,1,2];

  setStep(index: number) {
    this.step = index;
  }

  showStep(step){
    return this.steps.findIndex(d=>d==step)>-1?true:false;
  }

  async onModelChange(){
    this.prefLoading = true;
    if ( this.fieldProperties == null ){
      this.fieldProperties = {
        codecompany: this.codecompany,
        codecontract: this.uas.user.companylist.find(x=>x.codecompany==this.codecompany).codecontract,
        name: `CONFIG_${this.entityName.toUpperCase()}_${this.information.COLUMNNAME.toUpperCase()}`,
        preference:{
          decimal: ObjectUtil.isNotEmpty(this.decimal) ? this.decimal : null,
          defaultValue: ObjectUtil.isNotEmpty(this.defaultValue) ? this.defaultValue : null,
          readonly: this.readonly!=null ? this.readonly : this.information.ISREADONLY == 1 ? true : false,
          required: this.required!=null ? this.required : this.information.ISREQUIRED == 1 ? true : false,
          nullable: this.nullable!=null ? this.nullable : this.information.ISNULLABLE == 1 ? true : false,
          copyclean: this.copyclean,
          description: ObjectUtil.isNotEmpty(this.description) ? this.description : this.information.COLUMNDESC,
          decimalText: this.decimalText == null ? null : this.decimalText,
          nullableText: this.nullableText == null ? null : this.nullableText,
          requiredText: this.requiredText == null ? null : this.requiredText,
          readonlyText: this.readonlyText == null ? null : this.readonlyText,
          defaultValueText: this.defaultValueText == null ? null : this.defaultValueText,
          descriptionText: this.descriptionText == null ? null :  this.descriptionText,
          minLength: this.minLength == null ? null : this.minLength,
          maxLength: this.maxLength == null ? null : this.maxLength,
          minLengthText: this.minLengthText == null ? null : this.minLengthText,
          maxLengthText: this.maxLengthText == null ? null : this.maxLengthText,
          expression: this.expressionText == null ? null : this.expressionText,
          toolTiptext: this.toolTipText == null ? null : this.toolTipText
        }
      }  
    }else{
      
      this.fieldProperties.codecompany= this.codecompany;
      this.fieldProperties.codecontract= this.uas.user.companylist.find(x=>x.codecompany==this.codecompany).codecontract;
      this.fieldProperties.preference.defaultValue = ObjectUtil.isNotEmpty(this.defaultValue) ? this.defaultValue : null;
      this.fieldProperties.preference.readonly = this.readonly!=null ? this.readonly : this.information.ISREADONLY == 1 ? true : false;
      this.fieldProperties.preference.copyclean= this.copyclean;
      this.fieldProperties.preference.decimal = ObjectUtil.isNotEmpty(this.decimal) ? this.decimal : null;
      this.fieldProperties.preference.nullable = this.nullable!=null ? this.nullable : this.information.ISNULLABLE == 1 ? true : false;
      this.fieldProperties.preference.required = this.required!=null ? this.required : this.information.ISREQUIRED == 1 ? true : false;
      this.fieldProperties.preference.description = ObjectUtil.isNotEmpty(this.description) ? this.description : this.information.COLUMNDESC;
      this.fieldProperties.preference.decimalText = this.decimalText== null ? null : this.decimalText;
      this.fieldProperties.preference.nullableText = this.nullableText == null ? null : this.nullableText;
      this.fieldProperties.preference.requiredText = this.requiredText == null ? null : this.requiredText;
      this.fieldProperties.preference.readonlyText = this.readonlyText == null ? null : this.readonlyText;
      this.fieldProperties.preference.defaultValueText = this.defaultValueText == null ? null : this.defaultValueText;
      this.fieldProperties.preference.descriptionText = this.descriptionText == null ? null :  this.descriptionText;
      this.fieldProperties.preference.minLength = this.minLength == null ? null : this.minLength;
      this.fieldProperties.preference.maxLength = this.minLength == null ? null : this.maxLength;
      this.fieldProperties.preference.minLengthText = this.minLengthText == null ? null : this.minLengthText;
      this.fieldProperties.preference.maxLengthText = this.minLengthText == null ? null : this.maxLengthText;
      this.fieldProperties.preference.expression = this.expressionText == null ? null : this.expressionText;
      this.fieldProperties.preference.toolTiptext = this.toolTipText == null ? null : this.toolTipText;
    }    

    await this.ucs.savePreference(this.fieldProperties).then((data:string)=>{
        this.fieldProperties.internalid = data;
    }).catch(error=>{this.prefLoading = false;throw error;}).finally(()=>{this.prefLoading = false;});
  }

  ngOnInit(): void {
    
      this.information = this.data.data;
      this.entityDesc = this.data.entityDesc;
      this.entityName = this.data.entityName;
      this.steps = this.data.steps;
      this.row = this.data.row;
      this.group = this.data.group;
      
      if ( this.information!= null && this.information.VALIDATIONERROR != null ){
        try{
          let validation =  JSON.parse(this.information.VALIDATIONERROR);
          if ( validation['type']=='select' ){
            this.isSelectField = true;
            this.selectedValues = validation['options'];
          }
        }catch(error){}
      }


      if ( this.uas.user.companylist.length == 1){
        this.codecompany = this.uas.user.companylist[0].codecompany;
        if ( this.information != null ){
          this.loadProperties(this.codecompany);
        }
      }
  }

  loadProperties(codeCompany){
    this.fieldProperties = null;
    if ( codeCompany != null ){
      this.prefLoading = true;
      let name = "CONFIG_"+this.entityName.toUpperCase()+"_"+this.information.COLUMNNAME.toUpperCase();
      this.ucs.loadConfiguration(codeCompany,name,false).then((pref:FieldsProperties)=>{
          
          if ( pref!= null ){
            this.fieldProperties  = pref;
          }else{
            this.fieldProperties = null;
          }
          if ( this.fieldProperties != null ){
              this.copyclean = this.fieldProperties.preference.copyclean;
              this.defaultValue = this.fieldProperties.preference.defaultValue;
              this.readonly = this.fieldProperties.preference.readonly;
              this.decimal = this.fieldProperties.preference.decimal;
              this.nullable = this.fieldProperties.preference.nullable;
              this.required = this.fieldProperties.preference.required;
              this.description = this.fieldProperties.preference.description;
              this.readonlyText = this.fieldProperties.preference.requiredText;
              this.requiredText = this.fieldProperties.preference.requiredText;
              this.nullableText = this.fieldProperties.preference.nullableText;
              this.defaultValueText = this.fieldProperties.preference.defaultValueText;
              this.descriptionText = this.fieldProperties.preference.descriptionText;
              this.decimalText = this.fieldProperties.preference.decimalText;
              this.minLength = this.fieldProperties.preference.minLength;
              this.maxLength = this.fieldProperties.preference.maxLength;
              this.minLengthText = this.fieldProperties.preference.minLengthText;
              this.maxLengthText = this.fieldProperties.preference.maxLengthText;
              this.expressionText = this.fieldProperties.preference.expression;
              this.toolTipText = this.fieldProperties.preference.toolTiptext;

              if ( this.requiredText != null) {
                  this.required = false;
                  this.requiredForm = true;
              }else{
                  this.requiredForm = false;
              }
              if ( this.readonlyText != null) {
                this.readonly = false;
                this.readonlyForm = true;
              }else{
                this.readonlyForm = false;
              }
              if ( this.nullableText != null) {
                this.nullable = true;
                this.nullableForm = true;
              }else{
                this.nullableForm = false;
              }
              if ( this.defaultValueText != null ){
                this.defaultValue = null;
                this.defaultValueForm = true;
              }else{
                this.defaultValueForm = false;
              }
              if ( this.decimalText != null ){
                this.decimal = null;
                this.decimalForm = true;
              }else{
                this.decimalForm = false;
              }
              if ( this.descriptionText != null){
                this.description = null;
                this.descriptionForm = true;
              }else{
                this.descriptionForm = false;
              }
              if ( this.minLengthText != null){
                this.minLength = null;
                this.minLengthForm = true;
              }else{
                this.minLengthForm = false;
              }
              if ( this.maxLengthText != null){
                this.maxLength = null;
                this.maxLengthForm = true;
              }else{
                this.maxLengthForm = false;
              }


          }else{
              this.copyclean = false;
              this.defaultValue = null;
              this.readonly = false;
              this.decimal = null;
              this.nullable = true;
              this.required = false;
              this.description = null;
              this.readonlyText = null;
              this.requiredText = null;
              this.nullableText = null;
              this.defaultValueText = null;
              this.descriptionText = null;
              this.decimalText = null;
              this.minLengthText = null;
              this.minLength = null;
              this.maxLength = null;
              this.maxLengthText = null;
              this.expressionText = null;
              this.toolTipText = null;
          }
          
          this.prefLoading = false;
      }).catch(reaseon=>{
          this.prefLoading = false;
          throw reaseon;
      }).finally(()=>{
        this.prefLoading = false;
      })
    }else{
      this.prefLoading = true;
      return false;
    }
  }

  openFormula(type){
    
    let ob = {ts:true}
    ob['formula'] = this[type+'Text']; 
    let params:Variable[] = [];
    if ( this.row!= null ){
      Object.keys(this.row).forEach(key=>{
        if ( this.row[key]!=null && !(this.row[key] instanceof Object ) && !(this.row[key] instanceof Array ) ) {
          
          let param:Variable = {
              key: key,
              value: String(this.row[key]),
              type:'TEXTO'
          }
          params.push(param);
        }
      })  
    }
    //params.push('form',this.group);
    ob['variables'] = params;


    this.dialogServices.openGenericDialog(FormulaTesterComponent,ob,(f)=>{
      if ( f['formula']){
        this[type+'Text'] = f['formula'];
        this.onModelChange();
      }else{
        this[type+'Text'] = null;
        this[type+'Form'] = false;
        this.onModelChange();
      }
    },()=>{},'80vh','80vw',false,null,'S','80px');    
  }

  openText(){

    let data={
          showHeader:false,
          param:JSON.stringify([{
            parameterName: "AJUDA",
            parameterDesc:"Texto Informativo para Ajuda",
            parameterType:"RT"
          }]),
          newMode:true,
    }

    if ( this.toolTipText != null ){
      data['row'] = {
        "AJUDA":this.toolTipText
      }
    }

  
    this.dialogServices.openGenericDialog(CustomActionParametersComponent,data,(f:string)=>{
      let value:string = JSON.parse(String(f));
      this.toolTipText = value['AJUDA'];
      this.onModelChange();
    },()=>{},'80vh','80vw',false,null,'S','80px');    
  }
}
